/**
 * Program list for admin and migration.
 * Catalog programs (id, name) go to programs/; runtime templates (programId, weeklyTemplates) go to programTemplates/.
 */
import beginner_strength from './beginner_strength.json';
import court_basketball from './court_basketball.json';
import field_football from './field_football.json';
import field_soccer from './field_soccer.json';
import functional_advanced from './functional_advanced.json';
import functional_beginner from './functional_beginner.json';
import functional_intermediate from './functional_intermediate.json';
import longevity_general from './longevity_general.json';
import longevity_premenopause from './longevity_premenopause.json';
import multi_sport_olympic from './multi_sport_olympic.json';
import multi_sport_sprint from './multi_sport_sprint.json';
import rehab_general from './rehab_general.json';
import rehab_lower_body from './rehab_lower_body.json';
import rehab_upper_body from './rehab_upper_body.json';
import functionalBeginnerTemplate from './functional-beginner-template.json';
import samMultiSportTriathlon from './sam-multi-sport-sprint-triathlon.json';
import volleyball from './volleyball.json';

const all = [
  beginner_strength,
  court_basketball,
  field_football,
  field_soccer,
  functional_advanced,
  functional_beginner,
  functionalBeginnerTemplate,
  functional_intermediate,
  longevity_general,
  longevity_premenopause,
  multi_sport_olympic,
  multi_sport_sprint,
  rehab_general,
  rehab_lower_body,
  rehab_upper_body,
  samMultiSportTriathlon,
  volleyball,
];

/** Whether this doc is a runtime template (has programId + weeklyTemplates). */
function isRuntimeTemplate(p) {
  return p && (p.programId != null) && (p.weeklyTemplates != null);
}

/** Stable id for list/edit: catalog uses id, runtime uses programId. */
export function getProgramListId(p) {
  if (p.id) return p.id;
  if (p.programId) return p.programId;
  return null;
}

/** Program IDs that are published and ready for use. */
export const PUBLISHED_PROGRAM_IDS = ['volleyball', 'multi_sport_sprint'];

/** List of { id, name, type, published } for admin list. type is 'catalog' | 'template'. */
export const programList = all
  .map((p) => {
    const id = getProgramListId(p);
    if (!id) return null;
    const published = p.published === true || PUBLISHED_PROGRAM_IDS.includes(id);
    return { id, name: p.name || id, type: isRuntimeTemplate(p) ? 'template' : 'catalog', published };
  })
  .filter(Boolean);

/** All program JSON files: catalog and runtime. For migration. */
export const programDocuments = all;

/** Catalog-only docs (have top-level id, no weeklyTemplates). */
export const catalogPrograms = all.filter((p) => p.id && !isRuntimeTemplate(p));

/** Runtime template docs (have programId + weeklyTemplates). */
export const runtimeTemplates = all.filter(isRuntimeTemplate);

/** Get full program document by list id (for admin edit). */
export function getProgramByListId(listId) {
  if (!listId) return null;
  return all.find((p) => getProgramListId(p) === listId) || null;
}
